module.exports = __webpack_public_path__ + "files/1161e4561537d9455b705469fba3aa48.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/objects-2.png
// module id = 1617
// module chunks = 60